import { ApplicationWrapper } from "./components/ApplicationWrapper";
import "./gameInitializing";
import "./styles/desktop-structure.scss";
import "./styles/mobile-structure.scss";
import "./styles/fonts.scss";
import { ReconnectingModal } from "./components/ReconnectingModal";
import { Suspense, useEffect } from "react";
import { mainStore } from "./mainStore";
import { observer } from "mobx-react-lite";
import { Keyboard } from "./components/Keyboard";
import { keyboardStore } from "./mainStore/keyBoardStore";

const App = observer(() => {
  const { skin } = mainStore;
  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";

    const css = mainStore.skin.css ? mainStore.skin.css : "";

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    document.head.appendChild(style);
  }, [skin]);

  useEffect(() => {
    const scrollableDiv = document.getElementById("application-body");
    if (keyboardStore.isOpen) {
      scrollableDiv.style.height = `calc(100cqh - ${
        keyboardStore.keyBoardWrapperElement.getBoundingClientRect().height
      }px)`;
    } else {
      scrollableDiv.style.height = "100cqh";
    }
  }, [keyboardStore.isOpen]);

  return (
    <>
      <div id="application-body" className="application-body">
        <div className="blurBackground"></div>
        <ReconnectingModal />
        <Suspense fallback={<div />}>
          <ApplicationWrapper />
        </Suspense>
      </div>

      {keyboardStore.isOpen && <Keyboard />}
    </>
  );
});

export default App;
